import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { S as StateOptions } from './state-options.js';
import { n as numberOnlyHandler } from './utils4.js';
import { d as defineCustomElement$4 } from './form-control-error-text2.js';
import { d as defineCustomElement$3 } from './form-control-help-text2.js';
import { d as defineCustomElement$2 } from './form-control-select2.js';
import { d as defineCustomElement$1 } from './form-control-text2.js';

const IdentityAddressForm = /*@__PURE__*/ proxyCustomElement(class IdentityAddressForm extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.inputHandler = (name, value) => {
            this.address[name] = value;
            this.address = Object.assign({}, this.address);
        };
        this.handleFormUpdate = undefined;
        this.errors = undefined;
        this.defaultValues = undefined;
        this.address = {};
    }
    handleAddressChange(newValues) {
        this.handleFormUpdate(newValues);
    }
    render() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        return (h(Host, { key: 'd090676d3bb1d9de9ae947ff25d94b5985ace914', exportparts: "label,input,input-invalid" }, h("div", { key: '64ddec6db508d27b709ad551f60fe58494631fe3', class: "row gy-3" }, h("div", { key: '7e0f89b7b8d5a466b89efad75498c5d1f2cac8ea', class: "col-12 col-md-8" }, h("form-control-text", { key: 'ea6055fb3457e28666b11b72173ad70b83a87659', name: "line1", label: "Street Address", defaultValue: (_a = this.defaultValues) === null || _a === void 0 ? void 0 : _a.line1, errorText: (_b = this.errors) === null || _b === void 0 ? void 0 : _b.line1, inputHandler: this.inputHandler })), h("div", { key: '5f6f456c573fb9318e58976decb67274b209fa23', class: "col-12 col-md-4" }, h("form-control-text", { key: '86fffd4641953d0445a7c24d332cda513121b65e', name: "line2", label: "Apartment, Suite, etc. (optional)", defaultValue: (_c = this.defaultValues) === null || _c === void 0 ? void 0 : _c.line2, errorText: (_d = this.errors) === null || _d === void 0 ? void 0 : _d.line2, inputHandler: this.inputHandler })), h("div", { key: 'e06339cefebe37ae0629631fbc5101c9dbc040a6', class: "col-12" }, h("form-control-text", { key: 'd2af696b33092247b6741c8034aaf12ab51aa878', name: "city", label: "City", defaultValue: (_e = this.defaultValues) === null || _e === void 0 ? void 0 : _e.city, errorText: (_f = this.errors) === null || _f === void 0 ? void 0 : _f.city, inputHandler: this.inputHandler })), h("div", { key: 'b655a66fb68f059fa91ae5f9f60fdebe0ae04fad', class: "col-12 col-md-6" }, h("form-control-select", { key: '50a65861a5a39daac199571c5a0273340556e476', name: "state", label: "State", defaultValue: (_g = this.defaultValues) === null || _g === void 0 ? void 0 : _g.state, options: StateOptions, errorText: (_h = this.errors) === null || _h === void 0 ? void 0 : _h.state, inputHandler: this.inputHandler })), h("div", { key: '30255517e0fa1ede35d7b2525625ebc389c44525', class: "col-12 col-md-6" }, h("form-control-text", { key: 'b7b0a773c7b2dbe05c4bf8e9fc7235a01bf36832', name: "postal_code", label: "Postal Code", defaultValue: (_j = this.defaultValues) === null || _j === void 0 ? void 0 : _j.postal_code, errorText: (_k = this.errors) === null || _k === void 0 ? void 0 : _k.postal_code, maxLength: 5, keyDownHandler: numberOnlyHandler, inputHandler: this.inputHandler })), h("div", { key: '804e9aa1ca7b4ae167ae64969107ad6352559ed7', class: "col-12" }, h("form-control-select", { key: '1aa3734e10502bc8f1732f386b60135b8a7d94a6', name: "country", label: "Country", options: [{ label: 'United States', value: 'USA' }], inputHandler: this.inputHandler, defaultValue: (_l = this.defaultValues) === null || _l === void 0 ? void 0 : _l.country, errorText: (_m = this.errors) === null || _m === void 0 ? void 0 : _m.country,
            // just for now so we skip handling country specificities
            disabled: true })))));
    }
    static get watchers() { return {
        "address": ["handleAddressChange"]
    }; }
}, [0, "justifi-identity-address-form", {
        "handleFormUpdate": [16],
        "errors": [8],
        "defaultValues": [8, "default-values"],
        "address": [32]
    }, undefined, {
        "address": ["handleAddressChange"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["justifi-identity-address-form", "form-control-error-text", "form-control-help-text", "form-control-select", "form-control-text"];
    components.forEach(tagName => { switch (tagName) {
        case "justifi-identity-address-form":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, IdentityAddressForm);
            }
            break;
        case "form-control-error-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "form-control-help-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "form-control-select":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "form-control-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { IdentityAddressForm as I, defineCustomElement as d };
